var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"uploaderModalRef",attrs:{"hide-footer":"","size":"lg","title":_vm.title(),"hide-header-close":""},on:{"hide":function($event){return _vm.checkBeforeHideIt($event)}}},[_c('uploader',{attrs:{"folder":_vm.folder,"entry":_vm.entry},on:{"closeUploadModal":function($event){return _vm.hideUploader()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }